export const batteryLevel = (car, shouldDisplayBatteryInfo, siteSettingsData) => {
    let batteryLevel = {
        warning: 25,
        critical: 10
    };
    if (car.UseVoltage) return car.BatteryVoltage ? car.BatteryVoltage.toFixed(1) + 'v' : '?';
    if (car.BatteryLevel > 100) return '?';
    if (car.IsCharging) return '';                  // don't show % when on charge
    if (!shouldDisplayBatteryInfo && siteSettingsData && !siteSettingsData.ShowBatteryLevel && (car.BatteryLevel > batteryLevel.warning)) return '';   // don't show % while green unless admin or site has permission to see them
    return car.BatteryLevel ? car.BatteryLevel.toString() + '%' : '0%';
};